import "../../../Styles/TableOrderPage.css";
import React, { useEffect, useState } from "react";
import CrossIcon from "../../../Assests/Dashboard/cross.svg";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box, Grid } from "@mui/material";
import sortIcon from "../../../Assests/Category/SortingW.svg";
import {
  fetchOnlineStoreOrderData,
  fetchOrderChangeStatusData,
  getDeliveryStatus,
  getDeliveryCancelStatus,
  getOrderListCount,
  fetchDriverContact,
  fetchResolutionProtocol,
  fetchSupportEscalationPayload,
  // UberOrderList,
} from "../../../Redux/features/Orders/onlineStoreOrderSlice";
import { useSelector, useDispatch } from "react-redux";
// import DownIcon from "../../../Assests/Dashboard/Down.svg";
import axios from "axios";
import { BASE_URL, CLOSE_ORDER_COLLECT_CASH } from "../../../Constants/Config";

// import $ from "jquery";
// import "datatables.net-dt/css/jquery.dataTables.min.css";
import { SkeletonTable } from "../../../reuseableComponents/SkeletonTable";
import Pagination from "../../../AllUserComponents/Users/UnverifeDetails/Pagination";
import SelectDropDown from "../../../reuseableComponents/SelectDropDown";
import { useNavigate, Link } from "react-router-dom";

import {
  CurrencyInputHelperFun,
  formatDateNumeric,
  formatDateTime,
  transactionType,
} from "../../../Constants/utils";
import useDebounce from "../../../hooks/useDebouncs";
import AskConform from "../../../reuseableComponents/AskConform";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import { SortTableItemsHelperFun } from "../../../helperFunctions/SortTableItemsHelperFun";
import { isOnlineOrderPickedUpOrDelivered } from "../../../helperFunctions/orderCardDataHelper";
import {
  reportMkonnektOrderStatus,
  MKONNEKT_ORDER_STATUS,
} from "../../../services/mkonnekt/orderStatusReport";
import NoDataFound from "../../../reuseableComponents/NoDataFound";
import { format } from "date-fns";
import HoverInfoLogo from "../../../reuseableComponents/HoverInfoLogo";
import { PERMISSIONS } from "../../../Constants/permission";
import CROSS_UBER_DIRECT_BLACK from "../../../Assests/OrderRetireve/Black_Cross-01.svg";
import CROSS_UBER_DIRECT_WHITE from "../../../Assests/OrderRetireve/White_Cross-02.svg";
import Cancel_IMAGE from "../../../Assests/OrderRetireve/Cancel.svg";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import ConfirmModal from "../../../reuseableComponents/ConfirmModal";
import DriverContactModal from "../../../reuseableComponents/DriverContactModal";
import ResolutionActionModal from "../../../reuseableComponents/ResolutionActionModal";
import SupportEscalationModal from "../../../reuseableComponents/SupportEscalationModal";
import HoverToolTip from "../../../reuseableComponents/HoverToolTip";
import AccessDeniedTooltip from "../../../reuseableComponents/AccessDeniedTooltip";

const StyledTable = styled(Table)(({ theme }) => ({
  padding: 2, // Adjust padding as needed
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--qv-bg-253338, #253338)",
    color: theme.palette.common.white,
    fontFamily: "CircularSTDMedium !important",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
  [`&.${tableCellClasses.table}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    // backgroundColor: "var(--qv-bg-f5f5f5, #F5F5F5)",
  },
  "& td, & th": {
    borderBottom: "1px solid #E8E8E8",
  },
}));
const orderType = (type) => (type === "Completed" ? "Closed" : type);

const OnlineTableViewData = (props) => {
  const navigate = useNavigate();
  // console.log(props)
  const [allOnlineStoreOrder, setAllOnlineStoreOrders] = useState([]);
  // console.log("allOnlineStoreOrder", allOnlineStoreOrder);
  const AllInStoreDataState = useSelector((state) => state.onlineStoreOrder);
  // console.log("AllInStoreDataState", AllInStoreDataState);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const debouncedValue = useDebounce(props?.OnlSearchIdData);
  const [buttonLoader, setButtonLoader] = useState(false);

  const [cisHovered, setCIsHovered] = useState(false);
  const [choverId, setCHoverId] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [confirmfinalModalOpen, setConfirmFinalModalOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderID] = useState(null);
  const [userOrderList, setUserOrderList] = useState([]);
  const dispatch = useDispatch();
  const { permissions, status: statusPermission, error } = useSelector(
    (state) => state.permissions
  );
  const {
    LoginGetDashBoardRecordJson: { login_type, employee_id },
  } = useAuthDetails();
  // const debouncedValue = useDebounce(searchId);

  const [confirmCancelModalOpen, setConfirmCancelModalOpen] = useState(false);
  const [selectedCancelOrderId, setSelectedCancelOrderID] = useState(null);
  const [selectedCancelDeliveryOrderId, setSelectedCancelDeliveryOrderID] =
    useState(null);
  const [cancelData, setCancelData] = useState("");

  // QV-6039: state for the 3 new modals (driver contact / resolution protocol / support escalation)
  const [activeUberOrderId, setActiveUberOrderId] = useState(null);
  const [driverContactOpen, setDriverContactOpen] = useState(false);
  const [driverContactPayload, setDriverContactPayload] = useState(null);
  const [driverContactLoading, setDriverContactLoading] = useState(false);

  const [resolutionOpen, setResolutionOpen] = useState(false);
  const [resolutionPayload, setResolutionPayload] = useState(null);
  const [resolutionLoading, setResolutionLoading] = useState(false);

  const [supportOpen, setSupportOpen] = useState(false);
  const [supportPayload, setSupportPayload] = useState(null);
  const [supportLoading, setSupportLoading] = useState(false);

  const openDriverContact = async (orderId) => {
    setActiveUberOrderId(orderId || null);
    setDriverContactOpen(true);
    setDriverContactPayload(null);
    setDriverContactLoading(true);
    const payload = {
      order_id: orderId ? orderId.trim() : "",
      merchant_id: props.merchant_id?.trim(),
    };
    try {
      // Best-effort fresh sync with Uber so cached delivery_tracker is current
      // before we read driver contact info. Failure here is non-fatal — we
      // still try to render whatever the DB has.
      try {
        await dispatch(getDeliveryStatus(payload)).unwrap();
      } catch (syncErr) {
        console.warn("driver contact: live sync failed, falling back to cached data", syncErr);
      }
      const res = await dispatch(fetchDriverContact(payload)).unwrap();
      setDriverContactPayload(res?.data || null);
    } catch (e) {
      console.error("get_driver_contact failed", e);
      setDriverContactPayload({ status: false, message: "Failed to fetch driver contact" });
    } finally {
      setDriverContactLoading(false);
    }
  };

  const openResolutionProtocol = async (orderId) => {
    setActiveUberOrderId(orderId || null);
    setResolutionOpen(true);
    setResolutionPayload(null);
    setResolutionLoading(true);
    try {
      const res = await dispatch(
        fetchResolutionProtocol({
          order_id: orderId ? orderId.trim() : "",
          merchant_id: props.merchant_id?.trim(),
        })
      ).unwrap();
      setResolutionPayload(res?.data || null);
    } catch (e) {
      console.error("get_resolution_protocol failed", e);
      setResolutionPayload({ status: false, message: "Failed to fetch resolution protocol" });
    } finally {
      setResolutionLoading(false);
    }
  };

  const openSupportEscalation = async (orderId) => {
    setActiveUberOrderId(orderId || null);
    setSupportOpen(true);
    setSupportPayload(null);
    setSupportLoading(true);
    try {
      const res = await dispatch(
        fetchSupportEscalationPayload({
          order_id: orderId ? orderId.trim() : "",
          merchant_id: props.merchant_id?.trim(),
        })
      ).unwrap();
      setSupportPayload(res?.data || null);
    } catch (e) {
      console.error("support_escalation_payload failed", e);
      setSupportPayload({ status: false, message: "Failed to fetch support payload" });
    } finally {
      setSupportLoading(false);
    }
  };

  const cancelConfirmfun = async () => {
    const payload = {
      merchant_id: props.merchant_id?.trim(),
      order_id: selectedCancelOrderId ? selectedCancelOrderId?.trim() : "",
      delivery_id: selectedCancelDeliveryOrderId
        ? selectedCancelDeliveryOrderId?.trim()
        : "",
    };

    try {
      const res = await dispatch(getDeliveryCancelStatus(payload)).unwrap();
      if (res?.data?.status === true) {
        ToastifyAlert(res?.data?.message, "success");
        // fetchData();
        setTimeout(() => {
          fetchData();
        }, 500);
        setConfirmCancelModalOpen(false);
        setSelectedCancelDeliveryOrderID(null);
      }
    } catch (error) {
      console.error("Error", error);
    } finally {
      setConfirmCancelModalOpen(false);
      setSelectedCancelDeliveryOrderID(null);
    }
  };

  const handleDropDownChangeSafe = async (option) => {
    const hasUpdateOrderStatusPermission =
      (statusPermission !== "loading" && permissions.length === 0) ||
      permissions.includes(PERMISSIONS.MENU_UPDATE_ORDER_STATUS);
    const hasCancelOrderPermission =
      (statusPermission !== "loading" && permissions.length === 0) ||
      permissions.includes(PERMISSIONS.MENU_CANCEL_ORDER);
    if (!hasUpdateOrderStatusPermission) {
      ToastifyAlert("Access Denied", "error");
      return;
    }
    if (String(option?.value) === "5" && !hasCancelOrderPermission) {
      ToastifyAlert("Access Denied", "error");
      return;
    }

    const currentOrder = allOnlineStoreOrder.find(
      (order) => order.order_id === option?.orderId
    );

    if (
      currentOrder &&
      String(currentOrder.m_status) === String(option?.value)
    ) {
      return;
    }

    if (isOnlineOrderPickedUpOrDelivered(currentOrder)) {
      return;
    }

    return handleDropDownChange(option);
  };

  const transactionType = (type) => {
    if (type === "Cash") {
      return "Cash";
    } else if (type === "Credit Card") {
      return "Online";
    } else if (type === "Cash & Credit Card") {
      return "Both";
    } else {
      return type;
    }
  };


  // useEffect(() => {
  //   setCurrentPage(1);
  // }, [props?.OrderTypeData]);

  const fetchData = async () => {
    if (props?.selectedDateRange?.start_date) {
      let data = {
        merchant_id: props.merchant_id,
        order_type: orderType(props.OrderTypeData),
        // trans_type: transactionType(props.OrderSourceData),
        trans_type: transactionType(props.selectedTransaction),
        start_date: props.selectedDateRange?.start_date,
        end_date: props.selectedDateRange?.end_date,
        customer_id: "0",
        search_by:
          props?.OnlSearchIdData !== "" ? props?.OnlSearchIdData : null,
        perpage: rowsPerPage,
        page: debouncedValue === "" ? currentPage : "1",
        order_method: props.order_method ? props.order_method : "All",
        order_by: sortOrder.toUpperCase(),
        filter_by:
          filter_by === "name" ? `users.${filter_by}` : `my_order.${filter_by}`,
        // search_by: Boolean(debouncedValue.trim()) ? debouncedValue : null,
        ...props.userTypeData,
      };

      // try {
      //   const userOrderList = await dispatch(
      //     UberOrderList({ merchant_id: props.merchant_id?.trim() })
      //   );
      //   if (userOrderList?.payload?.length > 0) {
      //     setUserOrderList(userOrderList?.payload);
      //   } else {
      //     setUserOrderList([]);
      //   }
      // } catch (error) {
      //   console.error("Error", error);
      // }
      if (data) {
        dispatch(fetchOnlineStoreOrderData(data));
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [
    dispatch,
    //  props,
    props.selectedDateRange, //
    debouncedValue, //
    currentPage, //
    rowsPerPage, //
    props?.OrderTypeData,
    props.OrderSourceData,
    // AllInStoreDataState.OrderListCount,
  ]);

  const fetchOrderListCount = () => {
    setCurrentPage(1);
    const transactionType = (type) => {
      if (type === "Cash") {
        return "Cash";
      } else if (type === "Credit Card") {
        return "Online";
      } else if (type === "Cash & Credit Card") {
        return "Both";
      } else {
        return type;
      }
    };

    dispatch(
      getOrderListCount({
        merchant_id: props.merchant_id, //
        order_type: orderType(props.OrderTypeData),
        search_by:
          props?.OnlSearchIdData !== "" ? props?.OnlSearchIdData : null,
        // trans_type: transactionType(props.OrderSourceData), //
        trans_type: transactionType(props.selectedTransaction),
        start_date: props.selectedDateRange?.start_date, //
        end_date: props.selectedDateRange?.end_date, //
        order_method: props.order_method ? props.order_method : "All",
        ...props.userTypeData,
      })
    );
  };

  useEffect(() => {
    fetchOrderListCount();
  }, [
    dispatch,
    props.selectedDateRange,
    props.selectedDateRange?.start_date,
    props.selectedDateRange?.end_date,
    debouncedValue,
    props.order_method,
    props.OrderTypeData,
    props.OrderSourceData,
    // AllInStoreDataState.OrderListCount,
    // AllInStoreDataState.onlineStoreOrderData,
  ]);

  useEffect(() => {
    setTotalCount(AllInStoreDataState.OrderListCount);
  }, [AllInStoreDataState.OrderListCount]);

  useEffect(() => {
    if (
      !AllInStoreDataState.loading &&
      AllInStoreDataState.onlineStoreOrderData
    ) {
      const picupOrderSortedCanceledList =
        AllInStoreDataState?.onlineStoreOrderData?.filter(
          (order) => order.order_method === "pickup"
        );

      const deleveryOrderSortedList =
        AllInStoreDataState?.onlineStoreOrderData?.filter(
          (order) => order.order_method === "delivery"
        );
      setAllOnlineStoreOrders(
        props?.order_method === "pickup"
          ? picupOrderSortedCanceledList
          : props?.order_method === "delivery"
            ? deleveryOrderSortedList
            : AllInStoreDataState?.onlineStoreOrderData
      );
    }
  }, [AllInStoreDataState.loading, AllInStoreDataState.onlineStoreOrderData]);
  // console.log("AllInStoreDataState.stocktakeListCount",AllInStoreDataState)
  // for New order dropdown start.
  // useEffect(() => {
  //   const handleSelectChange = (event) => {
  //     const target = event.target;
  //     if (target.classList.contains("custom-selecttable")) {
  //       const orderId = target.getAttribute("data-order-id");
  //       const selectedOption = target.value;
  //       // console.log(`Order ID: ${orderId}, Selected Option: ${selectedOption}`);
  //       var success = window.confirm("Are you sure you want to change status");
  //       if (success == true) {
  //         const FormData = {
  //           merchant_id: props.merchant_id,
  //           order_id: orderId,
  //           m_status: selectedOption,
  //           ...props.userTypeData,
  //         };
  //         if (FormData) {
  //           // console.log("API call hogai");
  //           dispatch(fetchOrderChangeStatusData(FormData));
  //         }
  //       }
  //     }
  //   };
  //   const onlineStoreTable = document.getElementById("OnlineStoreTable");
  //   onlineStoreTable.addEventListener("change", handleSelectChange);

  //   return () => {
  //     onlineStoreTable.removeEventListener("change", handleSelectChange);
  //   };
  // }, []);
  // for New order dropdown end.

  const [showPriceModal, setShowPricModal] = useState(false);
  const [newReceivingAmount, setNewReceivingAmount] = useState("");
  const [newOrderId, setNewOrderId] = useState("");
  const [newOrderAmount, setNewOrderAmount] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // const openPricModal = () => {
  //   setShowPricModal(true);
  // };

  const closePricModal = () => {
    setErrorMessage("");
    setNewReceivingAmount("");
    setShowPricModal(false);
  };

  // for closed order edit button start.
  // useEffect(() => {
  //   const handleSelectclick = (event) => {
  //     const target = event.target;
  //     if (target.classList.contains("edit_center")) {
  //       const NeworderId = target.getAttribute("order-id");
  //       const Neworderamt = target.getAttribute("order-amt");
  //       setShowPricModal(true);
  //       setNewOrderId(NeworderId);
  //       setNewOrderAmount(Neworderamt);
  //     }
  //   };
  //   const onlineStoreTable = document.getElementById("OnlineStoreTable");
  //   onlineStoreTable.addEventListener("click", handleSelectclick);

  //   return () => {
  //     onlineStoreTable.removeEventListener("click", handleSelectclick);
  //   };
  // }, []);
  // for closed order edit button end.

  const changeReceivingAmount = (event) => {
    const inputValue = CurrencyInputHelperFun(event.target.value);
    setNewReceivingAmount(inputValue);
  };

  const handleAddReceivingAmount = async () => {
    const { token, ...otherUserData } = props.userTypeData;
    const newItem = {
      merchant_id: props.merchant_id,
      order_id: newOrderId,
      cash_collected: newReceivingAmount,
      order_amt: newOrderAmount,
    };
    const data = newItem;
    // console.log(data);
    const response = await axios.post(
      BASE_URL + CLOSE_ORDER_COLLECT_CASH,
      { ...data, ...otherUserData },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log(response);

    if (response?.data?.status == false) {
      setErrorMessage(response.data.message);
    } else {
      setErrorMessage("");
      setShowPricModal(false);
    }
  };

  // $.DataTable = require("datatables.net");
  function capitalizeFirstLetter(string, payemnt, status) {
    // console.log(payemnt);
    return payemnt == "Cash" && status == "5"
      ? "Cancelled"
      : payemnt == "Cash"
        ? "Cash"
        : "Credit Card";
    // return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const [deleteCategoryId, setDeleteCategoryId] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  // console.log("selectedDropdownItem", selectedDropdownItem, deleteCategoryId);

  const tableRow = ["Customer", "Order", "Amount", "Status", ""];
  const pickupStatusList = [
    {
      title: "Accepted",
      value: "1",
    },
    {
      title: "Packing",
      value: "2",
    },
    {
      title: "Ready",
      value: "3",
    },
    {
      title: "Completed",
      value: "4",
    },
    {
      title: "Cancel",
      value: "5",
    },
  ];
  const deliveryStatusList = [
    {
      title: "Accepted",
      value: "1",
    },
    {
      title: "Packing",
      value: "2",
    },
    {
      title: "Ready",
      value: "6",
    },
    {
      title: "Out for Delivery",
      value: "3",
    },
    {
      title: "Delivered",
      value: "4",
    },
    {
      title: "Cancel",
      value: "5",
    },
  ];

  // function getSelectedDropdownItem() {
  //   const data = allOnlineStoreOrder;
  //   const currentList =
  //     data && data.order_method === "pickup"
  //       ? pickupStatusList
  //       : deliveryStatusList;
  //   console.log(currentList, data, "data");
  //   let returnArr = []
  //   for(let i = 0; i < )
  //   return (
  //     data.find((item) => item.value === data.m_status) || { title: "" }
  //   );
  // }
  const [selectedDropdownItem, setSelectedDropdownItem] = useState(
    // getSelectedDropdownItem()
    {}
  );
  const handleDropDownChange = async (option) => {
    setDeleteCategoryId(option);
    setDeleteModalOpen(true);

    // Confirming with the user before proceeding
    // var success = window.confirm("Are you sure you want to change status");

    // // Proceed if the user confirms
    // if (success === true) {
    //   // Constructing form data to send to the server

    // }
  };

  const confirmChangeStatus = async () => {
    // If the selected status is the same as the current one,
    // do not proceed with status change.
    const currentOrder = allOnlineStoreOrder.find(
      (order) => order.order_id === deleteCategoryId?.orderId
    );

    if (
      currentOrder &&
      String(currentOrder.m_status) === String(deleteCategoryId?.value)
    ) {
      setDeleteCategoryId(null);
      setDeleteModalOpen(false);
      return;
    }

    if (isOnlineOrderPickedUpOrDelivered(currentOrder)) {
      setDeleteCategoryId(null);
      setDeleteModalOpen(false);
      return;
    }

    const FormData = {
      merchant_id: props.merchant_id,
      order_id: deleteCategoryId.orderId,
      m_status: deleteCategoryId.value,
      emp_id: employee_id,
      ...props.userTypeData,
    };

    // Dispatching an action to change the order status
    if (FormData) {
      try {
        setButtonLoader(true);
        const res = await dispatch(fetchOrderChangeStatusData(FormData));
        // Checking if the API call was successful
        if (res.meta.requestStatus === "fulfilled") {
          // Tobacco compliance: a cancelled order must be reported to mKonnekt as REFUNDED (the only
          // non-COMPLETED status it accepts), or the sale stays counted as manufacturer-funded volume
          // in the SkanData files. Deliberately OUTSIDE the state updater below — React may invoke
          // that function twice, which would double-fire. Fire-and-forget, and only once the server
          // actually confirmed the cancel: the thunk resolves "fulfilled" with an undefined payload
          // when the PHP endpoint answers status:false.
          // An order that never reached COMPLETE (m_status 4) was never reported, so there is nothing
          // to retract — skip the call when the row is known (a picked-up/delivered order cannot be
          // cancelled here, see the guard above). The server skips it too (never_reported); only an
          // order missing from the loaded list is left for the server to decide.
          const wasEverCompleted = !currentOrder || String(currentOrder.m_status ?? "").trim() === "4";
          if (
            String(deleteCategoryId.value) === "5" &&
            res.payload?.status === true &&
            wasEverCompleted
          ) {
            reportMkonnektOrderStatus({
              merchantId: props.merchant_id,
              orderId: deleteCategoryId.orderId,
              status: MKONNEKT_ORDER_STATUS.REFUNDED,
              description: "Order cancelled from the admin panel",
            });
          }
          // Update the local state with the updated order data
          setAllOnlineStoreOrders((prevState) => {
            // Find the index of the order to update
            const updatedStatusListItem = prevState.find(
              (order) => order.order_id === deleteCategoryId.orderId
            );
            if (updatedStatusListItem) {
              let updatedOrders;
              if (
                deleteCategoryId.value === "4" ||
                deleteCategoryId.value === "5"
              ) {
                updatedOrders = prevState.filter(
                  (order) => order.order_id !== deleteCategoryId.orderId
                );
              } else {
                const updatedOrder = {
                  ...updatedStatusListItem,
                  m_status: deleteCategoryId.value,
                };
                updatedOrders = prevState.map((order) =>
                  order.order_id === deleteCategoryId.orderId
                    ? updatedOrder
                    : order
                );
              }
              ToastifyAlert(res.payload.message, "success");
              if (res?.payload?.delivery_response) {
                ToastifyAlert(
                  // res.payload.delivery_response?.split("-")?.at(1),
                  res.payload.delivery_response,
                  "success",
                  10000
                );
              }
              return updatedOrders;
            } else {
              ToastifyAlert(res.payload.message, "error");
              // Order not found, return previous state unchanged
              return prevState;
            }
          });
        } else {
          // Handle other status codes or errors if needed
          console.error("Failed to update order status:", res.statusText);
          // Optionally show an error message or handle the error state
        }
      } catch (error) {
        console.error("Error while updating order status:", error.message);
        // Handle any network or other errors that may occur during the API call
      }
      setButtonLoader(false);
    }
    // console.log("deleteCategoryIddeleteCategoryId", deleteCategoryId);
    if (deleteCategoryId?.title === "Ready") {
      setSelectedDropdownItem(deleteCategoryId);
    } else {
      setSelectedDropdownItem({});
    }
    setDeleteCategoryId(null);
    setDeleteModalOpen(false);
    fetchData();
    fetchOrderListCount();
  };

  const orderStatus = (data) => {
    const hasUpdateOrderStatusPermission =
      !permissions.length ||
      permissions.includes(PERMISSIONS.MENU_UPDATE_ORDER_STATUS);
    const hasCancelOrderPermission =
      !permissions.length ||
      permissions.includes(PERMISSIONS.MENU_CANCEL_ORDER);

    if (props?.OrderTypeData === "All") {
      let OrderStatus = "";
      if (data.m_status == 5) {
        OrderStatus = "Cancelled";
      } else if (data.m_status == "7") {
        OrderStatus = "Refunded";
      } else if (data.m_status === "4" && data.order_method === "pickup") {
        OrderStatus = "Completed";
      } else if (data.m_status === "4" && data.order_method == "delivery") {
        OrderStatus = "Delivered";
      } else if (data.payment_id === "Cash") {
        OrderStatus = "Cash";
      } else {
        OrderStatus = "Credit Card";
      }

      if (OrderStatus == "Cancelled") {
        return "Cancelled";
      } else if (OrderStatus == "Refunded") {
        return "Refunded";
      } else if (OrderStatus == "Completed") {
        return "Completed";
      } else if (OrderStatus == "Delivered") {
        return "Delivered";
      } else if (data?.payment_id === "" || data?.payment_result !== "Approved"
        || data?.payment_result == null || data?.payment_id === null) { // Failed Order

        if (data?.is_tried === "0") {
          return (
            <>
              <p>Incomplete order</p>
              {data?.cvvResult && <p>{data?.cvvResult}</p>}
            </>
          );
        } else {
          return (
            <>
              <p>Failed payment</p>
              {data?.failResult && <p>{data?.failResult}</p>}
            </>
          );
        }

      } else {
        // return "Paid";

        // New Order
        const currentList =
          data && data.order_method === "pickup"
            ? pickupStatusList
            : deliveryStatusList;
        const cancelOption = {
          title: "Cancel",
          value: "5",
        };
        let dropdownOptions;
        if (data?.delivery_id) {
          // When delivery_id exists, show full delivery status list.
          // If current status is "Ready", also add "Cancel" (to allow cancelling only).
          // const canShowCancel =
          //   !permissions.length ||
          //   (permissions.includes(PERMISSIONS.MENU_CANCEL_ORDER) &&
          //     data?.payment_id === "Cash");
          // const isReadyDelivery =
          //   data?.order_method === "delivery" && data?.m_status === "6";

          // dropdownOptions =
          //   isReadyDelivery && canShowCancel
          //     ? [...currentList, cancelOption]
          //     : currentList;
          dropdownOptions = [...currentList, cancelOption];
        } else {
          // const withCanceledOption =
          //   !permissions.length ||
          //     (permissions.includes(PERMISSIONS.MENU_CANCEL_ORDER) &&
          //       data?.payment_id === "Cash")
          //     ? [
          //       ...currentList,
          //       ...(capitalizeFirstLetter(
          //         "",
          //         data?.payment_id,
          //         data?.m_status
          //       ) !== "Credit Card"
          //         ? [cancelOption]
          //         : [cancelOption]),
          //     ]
          //     : currentList;
          // console.log("console data inside withCanceledOption", withCanceledOption);
          // When there is NO delivery_id and status is "Out for Delivery",
          // hide the Cancel option from the dropdown.
          // dropdownOptions =
          //   data?.order_method === "delivery" && data?.m_status === "3"
          //     ? withCanceledOption.filter((item) => item.value !== "5")
          //     : withCanceledOption;
          dropdownOptions =
            data?.order_method === "delivery" && data?.m_status === "3"
              ? currentList.filter((item) => item.value !== "5")
              : currentList;
        }
        const selectedItem =
          currentList.find((item) => item.value === data.m_status) || {
            title: "",
          };

        const isLockedDeliveryStatus = !!data?.delivery_id;
        const isReadyDelivery =
          !!data?.delivery_id &&
          data?.order_method === "delivery" &&
          data?.m_status === "6";
        const isOutForDelivery =
          data?.order_method === "delivery" && data?.m_status === "3";
        const isOutForDeliveryWithDeliveryId =
          isOutForDelivery && !!data?.delivery_id;
        const isPickedUpOrDelivered = isOnlineOrderPickedUpOrDelivered(data);

        const statusDropdown = (
          <SelectDropDown
            listItem={dropdownOptions.map((item) => {
              const isCancelOption = item.value === "5";

              let disabled = false;

              if (isPickedUpOrDelivered) {
                disabled = true;
              } else if (isLockedDeliveryStatus) {
                if (isReadyDelivery) {
                  // When locked and currently "Ready", allow only "Cancel" to be clickable
                  disabled = !isCancelOption;
                } else if (isOutForDeliveryWithDeliveryId) {
                  // Delivery + delivery_id + "Out for Delivery": show all statuses read-only
                  disabled = true;
                } else {
                  // Other locked delivery states remain read-only
                  disabled = true;
                }
              } else if (isOutForDelivery) {
                // Without delivery_id and Out for Delivery: cannot go back to 1,2,6; can go to 4
                disabled = ["1", "2", "6"].includes(item.value);
              }
              // if (isCancelOption && !hasCancelOrderPermission) {
              //   disabled = true;
              // }

              return {
                ...item,
                orderId: data.order_id,
                disabled,
              };
            })}
            title={"title"}
            selectedOption={selectedItem.title}
            onClickHandler={handleDropDownChangeSafe}
            disabled={isPickedUpOrDelivered}
          />
        );

        return statusDropdown;
      }
    }

    if (props?.OrderTypeData === "New") {
      const currentList =
        data && data.order_method === "pickup"
          ? pickupStatusList
          : deliveryStatusList;
      const cancelOption = {
        title: "Cancel",
        value: "5",
      };
      let dropdownOptions;
      if (data?.delivery_id) {
        // When delivery_id exists, show full delivery status list.
        // If current status is "Ready", also add "Cancel" (to allow cancelling only).
        // const canShowCancel =
        //   !permissions.length ||
        //   (permissions.includes(PERMISSIONS.MENU_CANCEL_ORDER) &&
        //     data?.payment_id === "Cash");
        // const isReadyDelivery =
        //   data?.order_method === "delivery" && data?.m_status === "6";

        // dropdownOptions =
        //   isReadyDelivery && canShowCancel
        //     ? [...currentList, cancelOption]
        //     : currentList;
        dropdownOptions = currentList;
      } else {
        // const withCanceledOption =
        //   !permissions.length ||
        //     (permissions.includes(PERMISSIONS.MENU_CANCEL_ORDER) &&
        //       data?.payment_id === "Cash")
        //     ? [
        //       ...currentList,
        //       ...(capitalizeFirstLetter(
        //         "",
        //         data?.payment_id,
        //         data?.m_status
        //       ) !== "Credit Card"
        //         ? [cancelOption]
        //         : [cancelOption]),
        //     ]
        //     : currentList;

        // When there is NO delivery_id and status is "Out for Delivery",
        // hide the Cancel option from the dropdown.
        // dropdownOptions =
        //   data?.order_method === "delivery" && data?.m_status === "3"
        //     ? withCanceledOption.filter((item) => item.value !== "5")
        //     : withCanceledOption;

        dropdownOptions =
          data?.order_method === "delivery" && data?.m_status === "3"
            ? currentList.filter((item) => item.value !== "5")
            : currentList;
      }
      const selectedItem = currentList.find(
        (item) => item.value === data.m_status
      ) || { title: "" };
      // console.log("selectedItem", data, currentList, selectedItem);
      // setSelectedDropdownItem(selectedItem);

      const isLockedDeliveryStatus = !!data?.delivery_id;
      const isReadyDelivery =
        !!data?.delivery_id &&
        data?.order_method === "delivery" &&
        data?.m_status === "6";
      const isOutForDelivery =
        data?.order_method === "delivery" && data?.m_status === "3";
      const isOutForDeliveryWithDeliveryId =
        isOutForDelivery && !!data?.delivery_id;
      const isPickedUpOrDelivered = isOnlineOrderPickedUpOrDelivered(data);

      const statusDropdownNew = (
        <SelectDropDown
          listItem={dropdownOptions.map((item) => {
            const isCancelOption = item.value === "5";

            let disabled = false;

            if (isPickedUpOrDelivered) {
              disabled = true;
            } else if (isLockedDeliveryStatus) {
              if (isReadyDelivery) {
                // When locked and currently "Ready", allow only "Cancel" to be clickable
                disabled = !isCancelOption;
              } else if (isOutForDeliveryWithDeliveryId) {
                // Delivery + delivery_id + "Out for Delivery": show all statuses read-only
                disabled = true;
              } else {
                // Other locked delivery states remain read-only
                disabled = true;
              }
            } else if (isOutForDelivery) {
              // Without delivery_id and Out for Delivery: cannot go back to 1,2,6; can go to 4
              disabled = ["1", "2", "6"].includes(item.value);
            }
            // if (isCancelOption && !hasCancelOrderPermission) {
            //   disabled = true;
            // }

            return {
              ...item,
              orderId: data.order_id,
              disabled,
            };
          })}
          title={"title"}
          selectedOption={selectedItem.title}
          onClickHandler={handleDropDownChangeSafe}
          disabled={isPickedUpOrDelivered}
        />
      );

      return statusDropdownNew;
    }

    let PayStatus = "";
    let OrderStatus = "";

    if (data.m_status == 5) {
      OrderStatus = "Cancelled";
    } else if (data.m_status == "7") {
      OrderStatus = "Refunded";
    } else if (data.m_status === "4" && data.order_method === "pickup") {
      OrderStatus = "Completed";
    } else if (data.m_status === "4" && data.order_method == "delivery") {
      OrderStatus = "Delivered";
    } else if (data.payment_id === "Cash") {
      OrderStatus = "Cash";
    } else {
      OrderStatus = "Credit Card";
    }

    if (props?.OrderTypeData === "Completed") {
      // if (
      //   OrderStatus === "Cash" &&
      //   parseFloat(data?.cash_collected)?.toFixed(2) !=
      //     parseFloat(data?.amt)?.toFixed(2)
      // ) {
      //   return (
      //     <>
      //       <EditCashModel
      //         changeReceivingAmount={changeReceivingAmount}
      //         newReceivingAmount={newReceivingAmount}
      //         handleAddReceivingAmount={handleAddReceivingAmount}
      //         data={data}
      //         setNewOrderId={setNewOrderId}
      //         setNewOrderAmount={setNewOrderAmount}
      //       />
      //     </>
      //   );
      // } else
      if (OrderStatus == "Cancelled") {
        return "Cancelled";
      } else if (OrderStatus == "Refunded") {
        return "Refunded";
      } else if (OrderStatus == "Completed") {
        return "Completed";
      } else if (OrderStatus == "Delivered") {
        return "Delivered";
      } else {
        return "Paid";
      }
    }
    if (props?.OrderTypeData === "Failed") {
      if (data.is_tried === "0") {
        // return "Incomplete order";
        return (
          <>
            <p>Incomplete order</p>
            {data.cvvResult && <p>{data.cvvResult}</p>}
          </>
        );
      } else {
        return (
          <>
            <p>Failed payment</p>
            {data.failResult && <p>{data.failResult}</p>}
          </>
        );
        // return "Failed payment";
      }
    }
  };
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [sortOrder, setSortOrder] = useState("desc"); // "asc" for ascending, "desc" for descending
  const [filter_by, setFilter_by] = useState("merchant_time");
  const sortByItemName = (type, filter_by) => {
    // const { sortedItems, newOrder } = SortTableItemsHelperFun(
    //   allOnlineStoreOrder,
    //   type,
    //   name,
    //   sortOrder
    // );
    // setFilter_by(name)
    // setAllOnlineStoreOrders(sortedItems);
    // setSortOrder(newOrder);
    setCurrentPage(1);
    if (props?.selectedDateRange?.start_date) {
      let data = {
        merchant_id: props.merchant_id,
        order_type: orderType(props.OrderTypeData),
        // trans_type: transactionType(props.OrderSourceData),
        trans_type: transactionType(props.selectedTransaction),
        start_date: props.selectedDateRange?.start_date,
        end_date: props.selectedDateRange?.end_date,
        customer_id: "0",
        search_by:
          props?.OnlSearchIdData !== "" ? props?.OnlSearchIdData : null,
        perpage: rowsPerPage,
        page: 1, //debouncedValue === "" ? currentPage : "1",
        order_method: props.order_method ? props.order_method : "All",
        order_by: (sortOrder === "asc" ? "desc" : "asc").toUpperCase(),
        filter_by:
          filter_by === "name" ? `users.${filter_by}` : `my_order.${filter_by}`,
        // search_by: Boolean(debouncedValue.trim()) ? debouncedValue : null,
        ...props.userTypeData,
      };

      if (data) {
        dispatch(fetchOnlineStoreOrderData(data));
        setFilter_by(filter_by);
        setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
      }
    }
  };

  function getReadyBtn(data) {
    if (
      // data?.m_status == 6 &&
      data?.order_method === "delivery" &&
      // login_type === "superadmin" &&
      !!data?.delivery_id
      // userOrderList?.length > 0 &&
      // !userOrderList?.some((item) => item.order_id === data?.order_id)
    ) {
      return true;
    }
    return false;
  }

  const CancelUberBtn = !permissions.length || permissions.indexOf(PERMISSIONS.CANCEL_UBER_DELIVERY) > -1;

  //  !permissions.length || permissions.includes(PERMISSIONS.CANCEL_UBER_DELIVERY) 

  return (
    <>
      <Grid container className="box_shadow_div">
        <Grid item xs={12}>
          <Grid container sx={{ px: { xs: 1, md: 2.5 }, py: 2.5 }}>
            <Grid item xs={12}>
              <Pagination
                currentPage={currentPage}
                totalItems={totalCount}
                itemsPerPage={rowsPerPage}
                onPageChange={paginate}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                setCurrentPage={setCurrentPage}
                showEntries={true}
                data={AllInStoreDataState?.onlineStoreOrderData}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              {AllInStoreDataState.loading ? (
                <>
                  <SkeletonTable columns={tableRow} />
                </>
              ) : (
                <>
                  <TableContainer>
                    <StyledTable
                      sx={{ minWidth: 500 }}
                      aria-label="customized table"
                    >
                      <TableHead>
                        {/* {tableRow.map((item, index) => (
                          <StyledTableCell key={item}>{item}</StyledTableCell>
                        ))} */}
                      </TableHead>
                      <TableHead>
                        <StyledTableCell>
                          <button
                            className="flex items-center"
                            onClick={() =>
                              sortByItemName("str", "deliver_name")
                            }
                          >
                            <p className="whitespace-nowrap">Customer</p>
                            <HoverInfoLogo
                              title={"Name and contact details of the customer"}
                            />

                            <img src={sortIcon} alt="" className="pl-1" />
                          </button>
                        </StyledTableCell>
                        <StyledTableCell>
                          <button
                            className="flex items-center"
                            onClick={() =>
                              sortByItemName("date", "merchant_time")
                            }
                          >
                            <p>Order</p>
                            <HoverInfoLogo
                              title={
                                "Unique identifier for the order with the timestamp."
                              }
                            />

                            <img src={sortIcon} alt="" className="pl-1" />
                          </button>
                        </StyledTableCell>
                        <StyledTableCell>
                          <button
                            className="flex items-center"
                            onClick={() => sortByItemName("num", "amt")}
                          >
                            <p>Amount</p>
                            <HoverInfoLogo
                              title={"Total amount of the order"}
                            />

                            <img src={sortIcon} alt="" className="pl-1" />
                          </button>
                        </StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                        <StyledTableCell>
                          {/* <button
                            className="flex items-center"
                            onClick={() =>
                              sortByItemName("srt", "m_status")
                            }
                          > */}
                          <p>Status</p>
                          {/* <img src={sortIcon} alt="" className="pl-1" /> */}
                          {/* </button> */}
                        </StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                      </TableHead>
                      {/* {console.log(allOnlineStoreOrder)} */}
                      <TableBody>
                        {allOnlineStoreOrder &&
                          Object.entries(allOnlineStoreOrder).length > 0
                          ? Object.entries(allOnlineStoreOrder)?.map(
                            ([key, data], index) => {
                              ////////////////////Showing Status///////////////////////////
                              let status = "";
                              if (props?.OrderTypeData == "Failed") {
                                if (data.is_tried == "0") {
                                  status = "Incomplete order";
                                } else {
                                  status = "Failed payment";
                                }
                              } else {
                                if (data.payment_id === "Cash") {
                                  if (data.m_status === "4") {
                                    status = "Cash";
                                  } else {
                                    status = "Cash-Pending";
                                  }
                                } else {
                                  status = "Credit card";
                                }
                              }
                              /////////////////////end of Showing Stat////////////////////////////////

                              ////////////////////////pickup and delovery dropdown//////////////////////////////////////////

                              /////////////////////end pickup and delovery dropdown//////////////////////////////////////////

                              return (
                                <>
                                  <StyledTableRow key={index}>
                                    <StyledTableCell>
                                      <p className="text-[#000000] order_method">
                                        {data.deliver_name || ""}
                                        {data?.customer_type ? (
                                          <span className="existignCustomerData">
                                            ({data?.customer_type})
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </p>
                                      <p className="text-[#818181]">
                                        {data.users_email || ""}
                                      </p>
                                      <p className="text-[#818181]">
                                        {data.delivery_phn || ""}
                                      </p>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      <p className="text-[#000000] order_method">
                                        {data.order_id || ""}
                                      </p>
                                      <p className="text-[#818181]">
                                        {data.merchant_time
                                          ? format(
                                            new Date(data.merchant_time),
                                            "MM/dd/yyyy hh:mm a"
                                          )
                                          : ""}
                                      </p>
                                      <p className="text-[#818181] order_method">
                                        {data.order_method || ""}
                                      </p>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      <p>{"$" + data.amt || ""}</p>
                                      <p className="existignCustomerData1">
                                        {capitalizeFirstLetter(
                                          data.order_status || "",
                                          data.payment_id || "",
                                          data.m_status
                                        )}
                                      </p>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      {getReadyBtn(data) ? (
                                        <>
                                          <div
                                            className="uber_container flex flex-nowrap gap-2 items-center"
                                            style={{
                                              position: "relative",
                                              border: "1px solid var(--qv-bd-d1d5db, #d1d5db)",
                                              borderRadius: "8px",
                                              padding: "12px 10px 8px",
                                              marginTop: "10px",
                                              display: "inline-flex",
                                            }}
                                          >
                                            <span
                                              style={{
                                                position: "absolute",
                                                top: "-9px",
                                                left: "10px",
                                                background: "var(--qv-bg-ffffff, #fff)",
                                                padding: "0 6px",
                                                fontSize: "11px",
                                                fontWeight: 500,
                                                color: "var(--qv-tx-374151, #374151)",
                                                letterSpacing: "0.4px",
                                                textTransform: "uppercase",
                                                lineHeight: 1,
                                              }}
                                            >
                                              Uber Direct
                                            </span>
                                            {props.OrderTypeData === "Completed"
                                              || orderStatus(data) === "Delivered"
                                              || orderStatus(data) === "Refunded"
                                              || orderStatus(data) === "Cancelled"
                                              || (data?.order_method === "delivery" && data?.m_status === "3")
                                              ? (
                                                ""
                                              ) : (
                                                <AccessDeniedTooltip
                                                  hasPermission={CancelUberBtn}
                                                  onClick={() => {
                                                    if (
                                                      !(
                                                        data?.order_method === "delivery" &&
                                                        data?.m_status === "3"
                                                      )
                                                    ) {
                                                      setConfirmCancelModalOpen(true);
                                                      setSelectedCancelOrderID(data?.order_id);
                                                      setSelectedCancelDeliveryOrderID(
                                                        data?.delivery_id
                                                      );
                                                    }
                                                  }}
                                                >
                                                  <HoverToolTip title="Cancel Uber Delivery Only">
                                                    <button
                                                      onMouseEnter={() => {
                                                        setCIsHovered(true);
                                                        setCHoverId(index);
                                                      }}
                                                      onMouseLeave={() => {
                                                        setCIsHovered(false);
                                                        setCHoverId(null);
                                                      }}
                                                      className="cancel-uber-direct-btn"
                                                      disabled={
                                                        data?.order_method === "delivery" &&
                                                        data?.m_status === "3"
                                                      }
                                                    >
                                                      <img
                                                        src={Cancel_IMAGE}
                                                        alt="CANCEL_UBER_DIRECT_IMAGE"
                                                        style={{
                                                          objectFit: "contain",
                                                          width: "24px",
                                                          height: "24px",
                                                          transition: "0.2s all linear",
                                                        }}
                                                      />
                                                    </button>
                                                  </HoverToolTip>
                                                </AccessDeniedTooltip>
                                              )}
                                            {/* QV-6039: Driver contact / Resolution Action Center / Support escalation */}
                                            {data?.delivery_id ? (
                                              <>
                                                <HoverToolTip title="Contact Driver">
                                                  <button
                                                    type="button"
                                                    className="cancel-uber-direct-btn"
                                                    style={{ background: "var(--qv-bg-e3f2fd, #e3f2fd)", borderColor: "var(--qv-bd-1976d2, #1976d2)" }}
                                                    onClick={() => openDriverContact(data?.order_id)}
                                                  >
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1976d2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                                    </svg>
                                                  </button>
                                                </HoverToolTip>
                                                <HoverToolTip title="Resolution Action Center">
                                                  <button
                                                    type="button"
                                                    className="cancel-uber-direct-btn"
                                                    style={{ background: "var(--qv-bg-fff4e5, #fff4e5)", borderColor: "var(--qv-bd-ff9800, #ff9800)" }}
                                                    onClick={() => openResolutionProtocol(data?.order_id)}
                                                  >
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ff9800" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                                                      <line x1="12" y1="9" x2="12" y2="13" />
                                                      <line x1="12" y1="17" x2="12.01" y2="17" />
                                                    </svg>
                                                  </button>
                                                </HoverToolTip>
                                                <HoverToolTip title="Contact Quickvee Support">
                                                  <button
                                                    type="button"
                                                    className="cancel-uber-direct-btn"
                                                    style={{ background: "var(--qv-bg-e8f5e9, #e8f5e9)", borderColor: "var(--qv-bd-43a047, #43a047)" }}
                                                    onClick={() => openSupportEscalation(data?.order_id)}
                                                  >
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#43a047" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                      <circle cx="12" cy="12" r="10" />
                                                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                                                      <line x1="12" y1="17" x2="12.01" y2="17" />
                                                    </svg>
                                                  </button>
                                                </HoverToolTip>
                                              </>
                                            ) : null}
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      {/* {!permissions.length ||
                                        permissions.includes(
                                          PERMISSIONS.MENU_UPDATE_ORDER_STATUS
                                        )
                                        ? orderStatus(data)
                                        : ""} */}
                                      {orderStatus(data)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      <Link
                                        className="whitespace-nowrap text-[#0A64F9]"
                                        to={`/order/store-reporting/order-summary/${props.merchant_id}/${data?.order_id}`}
                                        // onClick={() => handleSummeryPage(row.order_id)}
                                        target="_blank"
                                      >
                                        View Details
                                        {/* Order Summery */}
                                        {/* <img src={Summery} alt="" className="pl-1" /> */}
                                      </Link>
                                    </StyledTableCell>
                                  </StyledTableRow>
                                </>
                              );
                            }
                          )
                          : ""}
                      </TableBody>
                    </StyledTable>
                    {!Object.entries(allOnlineStoreOrder).length && (
                      <NoDataFound table={true} />
                    )}
                  </TableContainer>
                </>
              )}
            </Grid>
          </Grid>
          <Grid container sx={{ py: 2.5, px: { xs: 1, sm: 2.5 } }}>
            <Grid item xs={12}>
              <Pagination
                currentPage={currentPage}
                totalItems={totalCount}
                itemsPerPage={rowsPerPage}
                onPageChange={paginate}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                setCurrentPage={setCurrentPage}
                showEntries={false}
                data={AllInStoreDataState?.onlineStoreOrderData}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {showPriceModal && (
        <div className="q-custom-modal-container" id="addtributes_">
          {/* Your modal JSX */}
          <div className="q-custom-modal-content">
            {/* Your modal content */}
            <div className="">
              <p className="q-custom-modal-header ">
                Cash Recieving
                <img
                  src={CrossIcon}
                  alt="icon"
                  className="ml-auto mb-4"
                  onClick={closePricModal}
                />
              </p>
            </div>
            {/* ... other modal content ... */}
            <input
              type="number"
              placeholder="Enter Amount"
              className="q-custom-input-field"
              value={newReceivingAmount}
              onChange={changeReceivingAmount}
            />
            <span className="input-error text-[#cc0000] text-[14px]">
              {errorMessage !== "" ? errorMessage : ""}
            </span>
            <div className="q-add-categories-section-middle-footer">
              <button
                onClick={handleAddReceivingAmount}
                className="quic-btn quic-btn-save"
              >
                Save
              </button>
              <button
                onClick={closePricModal}
                className="quic-btn quic-btn-cancle"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <AskConform
        headerText="change status"
        loader={buttonLoader}
        open={deleteModalOpen}
        onClose={() => {
          setDeleteModalOpen(false);
        }}
        onConfirm={confirmChangeStatus}
      />
      {/* <ConfirmModal
        headerText="Are you sure you want to assign this order to Uber Direct delivery?"
        open={confirmModalOpen}
        onClose={() => {
          setConfirmModalOpen(false);
          setSelectedOrderID(null);
        }}
        isHideImage={true}
        onConfirm={confirmFinalfun}
        isLoading={AllInStoreDataState?.uberLoading}
      /> */}

      <ConfirmModal
        headerText="Are you sure you want to cancel the Delivery?"
        open={confirmCancelModalOpen}
        onClose={() => {
          setConfirmCancelModalOpen(false);
          setSelectedCancelOrderID(null);
        }}
        isHideImage={true}
        onConfirm={cancelConfirmfun}
        isLoading={AllInStoreDataState?.uberLoading}
      />

      {/* QV-6039: Driver communication & resolution protocol modals */}
      <DriverContactModal
        open={driverContactOpen}
        onClose={() => setDriverContactOpen(false)}
        isLoading={driverContactLoading}
        payload={driverContactPayload}
      />
      <ResolutionActionModal
        open={resolutionOpen}
        onClose={() => setResolutionOpen(false)}
        isLoading={resolutionLoading}
        payload={resolutionPayload}
        onContactSupport={() => {
          setResolutionOpen(false);
          if (activeUberOrderId) {
            openSupportEscalation(activeUberOrderId);
          }
        }}
      />
      <SupportEscalationModal
        open={supportOpen}
        onClose={() => setSupportOpen(false)}
        isLoading={supportLoading}
        payload={supportPayload}
      />
    </>
  );
};

export default OnlineTableViewData;
